import { useState } from "react";
import { RNLongDescription } from "./RNLongDescription";
import { RNShortDescription } from "./RNShortDescription";

export const Preamble = () => {
    const [longDescription, setLongDescription] = useState(false);

    const showLongDescription = () => {
        setLongDescription(!longDescription);
    };

    return (
        <>
            <div className="text-center pt-3">
                {/* <h1 className="position-relative text-primary anton-regular-bg ">
                    Hitting the Right Note
                </h1> */}
                <img
                    className="img-fluid fancy-image"
                    src="/images/RightNoteNBase3.png"
                    alt=""
                />
            </div>
            {longDescription ? <RNLongDescription /> : <RNShortDescription />}
            <div className="d-flex justify-content-center text-primary pb-5">
                <button
                    className="btn btn-primary btn-md"
                    onClick={showLongDescription}
                >
                    {longDescription ? "Less information" : "More Information"}
                </button>
            </div>
        </>
    );
};
